import React from 'react'

const TONES = {
  pdf: 'bg-background text-dark-blue',
  xlsx: 'bg-success bg-opacity-10 text-success',
  csv: 'bg-danger bg-opacity-10 text-danger'
}

export default function ReportFormatTag({ format }) {
  const key = (format ?? '').toLowerCase()

  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-lg text-xs font-medium uppercase whitespace-nowrap ${TONES[key] || TONES.pdf}`}>
      {format || '--'}
    </span>
  )
}
